import React from "react";
import { CasesFeedbackModal } from "../../FeedbackModal/CasesFeedback";
import "./Feedback.scss";

const Feedback = ({ data }) => {
    return (
        <div className="feedback-section-wrapper" style={{ padding: '20px' }}>
            <CasesFeedbackModal 
                open={true} 
                setOpen={() => {}} 
                data={data} 
                isModal={false} 
            />
        </div>
    );
};

export default Feedback;
